import { Component, OnInit, EventEmitter, Output, Input, ViewChildren, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service'
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api'
import { SopDetail, SopStep } from '../Models'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PhBhpStartSopobserveComponent } from '../ph-bhp-start-sopobserve/ph-bhp-start-sopobserve.component';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslateService } from "@ngx-translate/core";
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-select-sopobserve',
  templateUrl: './ph-bhp-select-sopobserve.component.html',
  styleUrls: ['./ph-bhp-select-sopobserve.component.css']
})
export class PhBhpSelectSopobserveComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  modalRef: BsModalRef;
  @Input() userData;
  @Input() formdata;
  @Input() isDesktop: boolean;
  @Output() childData = new EventEmitter();
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChildren('sopList') sopList;
  emitData: any = {
    key: "",
    val: ""
  }
  activeClass: Object = {};
  sopDetailList: Array<SopDetail> = [];
  sopDetail: SopDetail = {} as SopDetail;
  selectIndex: number;
  radioSelected: any;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(private service: PhBhpFeaturePackageSopobservationService, public layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public appConfig: AppConfig, public translate: TranslateService) { }

  ngOnInit() {

    this.getSOPObservationList()
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.getSOPObservationList()
    });
    this.layoutService.lang.subscribe((res) => {
      this.formdata.subCategoryName = this.layoutService.getSubCategoryName(this.formdata.subCategory);
    });
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  getSOPTitle(titleId) {
    return this.layoutService.translateText(titleId, '');
  }

  getSOPDescription(descriptionId) {
    return this.layoutService.translateText(descriptionId, '');
  }

  getSOPObservationList() {
    this.layoutService.showLoader = true
    this.service.getSOPObservationList(this.userData.userId, this.userData.roleName.roleId, this.layoutService.institutionID)
      .subscribe((res: Array<SopDetail>) => {
        this.layoutService.showLoader = false
        this.sopDetailList = res;
      });
  }

  getSOPTranslation(sopTrlID) {
    return this.layoutService.translateText(sopTrlID, '');
  }

  selectSop(index) {
    this.selectIndex = index;
    this.activeClass = {};
    this.activeClass[index] = true;
    this.radioSelected = index;

  }
  openSopDetails() {
    if (this.selectIndex != null) {
      this.sopDetail = this.sopDetailList[this.selectIndex];
      if (this.isDesktop) {
        var initialState = {
          isDesktop: true,
          userData: this.userData, formdata: this.formdata, sopDetail: this.sopDetail,
          institutions: this.appConfig.institutions,
        };
        this.modalRef = this.modalService.show(PhBhpStartSopobserveComponent, { initialState, class: 'modal-full w-full' });
        this.modalRef.content.action.subscribe((value) => {
          switch (value.key) {
            case 'saveSuccess':
              this.selectIndex = null;
              this.activeClass = {};
              this.service.isCollapsed = !this.service.isCollapsed;
              this.closeModal();
              // this.modalRef = this.modalService.show(this.template,
              //   Object.assign({}, { class: 'w-420 yes-no-modal' }));
              break;
          }
        });
      } else {
        this.childData.emit({ sopDetail: this.sopDetail, userData: this.userData, formdata: this.formdata, key: 'startSopObserve' });
      }
    } else if (!this.isDesktop) {
      this.childData.emit({ 'key': 'SopNotSelected' });
    } else {
      this.layoutService.showError(this.layoutService.translateText('Select a SOP and then start observing'));
    }
  }
  closeWindow() {
    this.modalRef.hide();
  }
  backToNewObserve() {
    this.emitData = {};
    this.emitData.key = "back";
    this.childData.emit(this.emitData);
  }
  startOpobserveChildData(value) {
    switch (value.key) {
      case 'saveSuccess':
        this.selectIndex = null;
        this.activeClass = {};
        this.service.isCollapsed = !this.service.isCollapsed;
        this.closeModal();
        // this.modalRef = this.modalService.show(this.template,
        //   Object.assign({}, { class: 'w-420 yes-no-modal' }));
        break;
    }
  }
  closeModal() {
    this.childData.emit({ key: "saveSuccess" });
  }

  disableStartObservation() {
    return ((this.selectIndex === undefined || this.selectIndex === null));
  }

  errImg(e:Event){
    e.target['src'] = 'assets/img/fallback-img.png';
  }
}
